export const assetRequire = (path) => `https://assets.jewlr.com/${path}`
